export default `/* Ids Layout Flex Component */
/* Ids Layout Flex Item Component */
:host([align-self=auto]),
.ids-layout-flex-item-align-self-auto {
  align-self: auto;
}

:host([align-self=baseline]),
.ids-layout-flex-item-align-self-baseline {
  align-self: baseline;
}

:host([align-self=center]),
.ids-layout-flex-item-align-self-center {
  align-self: center;
}

:host([align-self=stretch]),
.ids-layout-flex-item-align-self-stretch {
  align-self: stretch;
}

:host([align-self=flex-start]),
.ids-layout-flex-item-align-self-flex-start {
  align-self: flex-start;
}

:host([align-self=flex-end]),
.ids-layout-flex-item-align-self-flex-end {
  align-self: flex-end;
}

:host([grow="0"]),
.ids-layout-flex-item-grow-0 {
  flex-grow: 0;
}

:host([grow="1"]),
.ids-layout-flex-item-grow-1 {
  flex-grow: 1;
}

:host([grow="1"]) {
  min-height: 0;
}

:host([shrink="0"]),
.ids-layout-flex-item-shrink-0 {
  flex-shrink: 0;
}

:host([shrink="1"]),
.ids-layout-flex-item-shrink-1 {
  flex-shrink: 1;
}

:host([flex="1"]),
.ids-layout-flex-item-flex-1 {
  flex: 1;
}

:host([flex="2"]),
.ids-layout-flex-item-flex-2 {
  flex: 2;
}

:host([flex="3"]),
.ids-layout-flex-item-flex-3 {
  flex: 3;
}

:host([flex="4"]),
.ids-layout-flex-item-flex-4 {
  flex: 4;
}

:host([flex="5"]),
.ids-layout-flex-item-flex-5 {
  flex: 5;
}

:host([flex="6"]),
.ids-layout-flex-item-flex-6 {
  flex: 6;
}

:host([flex="7"]),
.ids-layout-flex-item-flex-7 {
  flex: 7;
}

:host([flex="8"]),
.ids-layout-flex-item-flex-8 {
  flex: 8;
}

:host([flex="9"]),
.ids-layout-flex-item-flex-9 {
  flex: 9;
}

:host([flex="10"]),
.ids-layout-flex-item-flex-10 {
  flex: 10;
}

:host([flex="11"]),
.ids-layout-flex-item-flex-11 {
  flex: 11;
}

:host([flex="12"]),
.ids-layout-flex-item-flex-12 {
  flex: 12;
}

:host([flex="13"]),
.ids-layout-flex-item-flex-13 {
  flex: 13;
}

:host([flex="14"]),
.ids-layout-flex-item-flex-14 {
  flex: 14;
}

:host([flex="15"]),
.ids-layout-flex-item-flex-15 {
  flex: 15;
}

:host([flex="16"]),
.ids-layout-flex-item-flex-16 {
  flex: 16;
}

:host([flex="17"]),
.ids-layout-flex-item-flex-17 {
  flex: 17;
}

:host([flex="18"]),
.ids-layout-flex-item-flex-18 {
  flex: 18;
}

:host([flex="19"]),
.ids-layout-flex-item-flex-19 {
  flex: 19;
}

:host([flex="20"]),
.ids-layout-flex-item-flex-20 {
  flex: 20;
}

:host([flex="21"]),
.ids-layout-flex-item-flex-21 {
  flex: 21;
}

:host([flex="22"]),
.ids-layout-flex-item-flex-22 {
  flex: 22;
}

:host([flex="23"]),
.ids-layout-flex-item-flex-23 {
  flex: 23;
}

:host([flex="24"]),
.ids-layout-flex-item-flex-24 {
  flex: 24;
}

:host([overflow=auto]),
.ids-layout-flex-item-overflow-auto {
  overflow: auto;
}

:host([overflow=hidden]),
.ids-layout-flex-item-overflow-hidden {
  overflow: hidden;
}

:host([overflow=visible]),
.ids-layout-flex-item-overflow-visible {
  overflow: visible;
}

:host([overflow=scroll]),
.ids-layout-flex-item-overflow-scroll {
  overflow: scroll;
}

:host(.has-container-grid[grow="0"][shrink="0"]),
.ids-layout-flex-item.has-container-grid.ids-layout-flex-item-grow-0.ids-layout-flex-item-shrink-0 {
  width: 100%;
}

::slotted(ids-input[size=full]) {
  display: inline-block;
}

:host(.has-button) ::slotted(ids-button) {
  --ids-button-min-height: var(--ids-layout-flex-input-height, 34px);
  height: var(--ids-layout-flex-input-height, auto);
}

:host([hide]) {
  display: none;
}

@container (width >= 320px) {
  :host([hide=xs]) {
    display: block;
  }
}
@container (width >= 767px) {
  :host([hide=sm]) {
    display: block;
  }
}
@container (width >= 927px) {
  :host([hide=md]) {
    display: block;
  }
}
@container (width >= 928px) {
  :host([hide=lg]) {
    display: block;
  }
}
@container (width >= 1183px) {
  :host([hide=xl]) {
    display: block;
  }
}
@container (width >= 2463px) {
  :host([hide=xxl]) {
    display: block;
  }
}
@media (width >= 320px) {
  :host([hide=xs]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 767px) {
  :host([hide=sm]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 927px) {
  :host([hide=md]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 928px) {
  :host([hide=lg]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 1183px) {
  :host([hide=xl]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 2463px) {
  :host([hide=xxl]:not(.in-container)) {
    display: block;
  }
}
:host([hide=always]) {
  display: none;
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  flex-grow: 1;
  min-block-size: 0;
  overflow: hidden;
}

:host,
.ids-layout-flex {
  display: flex;
}

:host([hidden]) {
  display: none;
}

:host([display=inline-flex]),
.ids-layout-flex-display-inline-flex {
  display: inline-flex;
}

:host([align-content=flex-start]),
.ids-layout-flex-align-content-flex-start {
  align-content: flex-start;
}

:host([align-content=flex-end]),
.ids-layout-flex-align-content-flex-end {
  align-content: flex-end;
}

:host([align-content=center]),
.ids-layout-flex-align-content-center {
  align-content: center;
}

:host([align-content=space-between]),
.ids-layout-flex-align-content-space-between {
  align-content: space-between;
}

:host([align-content=space-around]),
.ids-layout-flex-align-content-space-around {
  align-content: space-around;
}

:host([align-content=space-evenly]),
.ids-layout-flex-align-content-space-evenly {
  align-content: space-evenly;
}

:host([align-content=stretch]),
.ids-layout-flex-align-content-stretch {
  align-content: stretch;
}

:host([align-content=start]),
.ids-layout-flex-align-content-start {
  align-content: start;
}

:host([align-content=end]),
.ids-layout-flex-align-content-end {
  align-content: end;
}

:host([align-content=baseline]),
.ids-layout-flex-align-content-baseline {
  align-content: baseline;
}

:host([align-items=start]),
.ids-layout-flex-align-items-start {
  align-items: start;
}

:host([align-items=end]),
.ids-layout-flex-align-items-end {
  align-items: end;
}

:host([align-items=flex-start]),
.ids-layout-flex-align-items-flex-start {
  align-items: flex-start;
}

:host([align-items=flex-end]),
.ids-layout-flex-align-items-flex-end {
  align-items: flex-end;
}

:host([align-items=center]),
.ids-layout-flex-align-items-center {
  align-items: center;
}

:host([align-items=baseline]),
.ids-layout-flex-align-items-baseline {
  align-items: baseline;
}

:host([align-items=stretch]),
.ids-layout-flex-align-items-stretch {
  align-items: stretch;
}

:host([align-items=center-inputs]),
.ids-layout-flex-align-items-center-inputs {
  align-items: start;
}

:host([align-items=center-inputs]) {
  --ids-layout-flex-input-height: var(--ids-input-height-30);
  --ids-checkbox-inline-min-height: var(--ids-layout-flex-input-height);
}
:host([align-items=center-inputs]) ::slotted(ids-layout-flex-item.has-checkbox) {
  align-self: end;
}
:host([align-items=center-inputs]) ::slotted(ids-layout-flex-item.has-button) {
  align-self: start;
  min-height: var(--ids-layout-flex-input-height);
  display: flex;
  align-items: center;
}

:host([align-items=center-inputs].has-top-label-field:not(.has-wrapped-button)) ::slotted(ids-layout-flex-item.has-button) {
  margin-block-start: calc(var(--ids-input-label-font-size) * 1.25 + var(--ids-input-margin-bottom));
}

:host([align-items=center-inputs][field-height=xs]) {
  --ids-layout-flex-input-height: var(--ids-input-height-10);
}

:host([align-items=center-inputs][field-height=sm]) {
  --ids-layout-flex-input-height: var(--ids-input-height-20);
}

:host([align-items=center-inputs][field-height=lg]) {
  --ids-layout-flex-input-height: var(--ids-input-height-40);
}

:host([direction=row]),
.ids-layout-flex-direction-row {
  flex-direction: row;
}

:host([direction=row-reverse]),
.ids-layout-flex-direction-row-reverse {
  flex-direction: row-reverse;
}

:host([direction=column]),
.ids-layout-flex-direction-column {
  flex-direction: column;
}

:host([direction=column-reverse]),
.ids-layout-flex-direction-column-reverse {
  flex-direction: column-reverse;
}

:host([justify-content=start]),
.ids-layout-flex-justify-content-start {
  justify-content: start;
}

:host([justify-content=stretch]),
.ids-layout-flex-justify-content-stretch {
  justify-content: stretch;
}

:host([justify-content=end]),
.ids-layout-flex-justify-content-end {
  justify-content: end;
}

:host([justify-content=flex-start]),
.ids-layout-flex-justify-content-flex-start {
  justify-content: flex-start;
}

:host([justify-content=flex-end]),
.ids-layout-flex-justify-content-flex-end {
  justify-content: flex-end;
}

:host([justify-content=center]),
.ids-layout-flex-justify-content-center {
  justify-content: center;
}

:host([justify-content=left]),
.ids-layout-flex-justify-content-left {
  justify-content: left;
}

:host([justify-content=right]),
.ids-layout-flex-justify-content-right {
  justify-content: right;
}

:host([justify-content=space-between]),
.ids-layout-flex-justify-content-space-between {
  justify-content: space-between;
}

:host([justify-content=space-around]),
.ids-layout-flex-justify-content-space-around {
  justify-content: space-around;
}

:host([justify-content=space-evenly]),
.ids-layout-flex-justify-content-space-evenly {
  justify-content: space-evenly;
}

:host([wrap=nowrap]),
.ids-layout-flex-wrap-nowrap {
  flex-wrap: nowrap;
}

:host([wrap=wrap]),
.ids-layout-flex-wrap-wrap {
  flex-wrap: wrap;
}

:host([wrap=wrap-reverse]),
.ids-layout-flex-wrap-wrap-reverse {
  flex-wrap: wrap-reverse;
}

:host([gap="0"]),
.ids-layout-flex-gap-0 {
  gap: 0px;
}

:host([gap="1"]),
.ids-layout-flex-gap-1 {
  gap: 1px;
}

:host([gap="2"]),
.ids-layout-flex-gap-2 {
  gap: 2px;
}

:host([gap="4"]),
.ids-layout-flex-gap-4 {
  gap: 4px;
}

:host([gap="8"]),
.ids-layout-flex-gap-8 {
  gap: 8px;
}

:host([gap="12"]),
.ids-layout-flex-gap-12 {
  gap: 12px;
}

:host([gap="16"]),
.ids-layout-flex-gap-16 {
  gap: 16px;
}

:host([gap="20"]),
.ids-layout-flex-gap-20 {
  gap: 20px;
}

:host([gap="24"]),
.ids-layout-flex-gap-24 {
  gap: 24px;
}

:host([gap="28"]),
.ids-layout-flex-gap-28 {
  gap: 28px;
}

:host([gap="32"]),
.ids-layout-flex-gap-32 {
  gap: 32px;
}

:host([gap="36"]),
.ids-layout-flex-gap-36 {
  gap: 36px;
}

:host([gap="40"]),
.ids-layout-flex-gap-40 {
  gap: 40px;
}

:host([gap-x="0"]),
.ids-layout-flex-gap-x-0 {
  row-gap: 0px;
}

:host([gap-x="1"]),
.ids-layout-flex-gap-x-1 {
  row-gap: 1px;
}

:host([gap-x="2"]),
.ids-layout-flex-gap-x-2 {
  row-gap: 2px;
}

:host([gap-x="4"]),
.ids-layout-flex-gap-x-4 {
  row-gap: 4px;
}

:host([gap-x="8"]),
.ids-layout-flex-gap-x-8 {
  row-gap: 8px;
}

:host([gap-x="12"]),
.ids-layout-flex-gap-x-12 {
  row-gap: 12px;
}

:host([gap-x="16"]),
.ids-layout-flex-gap-x-16 {
  row-gap: 16px;
}

:host([gap-x="20"]),
.ids-layout-flex-gap-x-20 {
  row-gap: 20px;
}

:host([gap-x="24"]),
.ids-layout-flex-gap-x-24 {
  row-gap: 24px;
}

:host([gap-x="28"]),
.ids-layout-flex-gap-x-28 {
  row-gap: 28px;
}

:host([gap-x="32"]),
.ids-layout-flex-gap-x-32 {
  row-gap: 32px;
}

:host([gap-x="36"]),
.ids-layout-flex-gap-x-36 {
  row-gap: 36px;
}

:host([gap-x="40"]),
.ids-layout-flex-gap-x-40 {
  row-gap: 40px;
}

:host([gap-y="0"]),
.ids-layout-flex-gap-y-0 {
  column-gap: 0px;
}

:host([gap-y="1"]),
.ids-layout-flex-gap-y-1 {
  column-gap: 1px;
}

:host([gap-y="2"]),
.ids-layout-flex-gap-y-2 {
  column-gap: 2px;
}

:host([gap-y="4"]),
.ids-layout-flex-gap-y-4 {
  column-gap: 4px;
}

:host([gap-y="8"]),
.ids-layout-flex-gap-y-8 {
  column-gap: 8px;
}

:host([gap-y="12"]),
.ids-layout-flex-gap-y-12 {
  column-gap: 12px;
}

:host([gap-y="16"]),
.ids-layout-flex-gap-y-16 {
  column-gap: 16px;
}

:host([gap-y="20"]),
.ids-layout-flex-gap-y-20 {
  column-gap: 20px;
}

:host([gap-y="24"]),
.ids-layout-flex-gap-y-24 {
  column-gap: 24px;
}

:host([gap-y="28"]),
.ids-layout-flex-gap-y-28 {
  column-gap: 28px;
}

:host([gap-y="32"]),
.ids-layout-flex-gap-y-32 {
  column-gap: 32px;
}

:host([gap-y="36"]),
.ids-layout-flex-gap-y-36 {
  column-gap: 36px;
}

:host([gap-y="40"]),
.ids-layout-flex-gap-y-40 {
  column-gap: 40px;
}

:host([gap=none]),
.ids-layout-flex-gap-none {
  gap: 0;
}

:host([gap-x=none]),
.ids-layout-flex-gap-x-none {
  row-gap: 0;
}

:host([gap-y=none]),
.ids-layout-flex-gap-y-none {
  column-gap: 0;
}

:host([gap=xs]),
.ids-layout-flex-gap-xs {
  gap: 8px;
}

:host([gap-x=xs]),
.ids-layout-flex-gap-x-xs {
  row-gap: 8px;
}

:host([gap-y=xs]),
.ids-layout-flex-gap-y-xs {
  column-gap: 8px;
}

:host([gap=sm]),
.ids-layout-flex-gap-sm {
  gap: 16px;
}

:host([gap-x=sm]),
.ids-layout-flex-gap-x-sm {
  row-gap: 16px;
}

:host([gap-y=sm]),
.ids-layout-flex-gap-y-sm {
  column-gap: 16px;
}

:host([gap=md]),
.ids-layout-flex-gap-md {
  gap: 24px;
}

:host([gap-x=md]),
.ids-layout-flex-gap-x-md {
  row-gap: 24px;
}

:host([gap-y=md]),
.ids-layout-flex-gap-y-md {
  column-gap: 24px;
}

:host([gap=lg]),
.ids-layout-flex-gap-lg {
  gap: 32px;
}

:host([gap-x=lg]),
.ids-layout-flex-gap-x-lg {
  row-gap: 32px;
}

:host([gap-y=lg]),
.ids-layout-flex-gap-y-lg {
  column-gap: 32px;
}

:host([gap=xl]),
.ids-layout-flex-gap-xl {
  gap: 40px;
}

:host([gap-x=xl]),
.ids-layout-flex-gap-x-xl {
  row-gap: 40px;
}

:host([gap-y=xl]),
.ids-layout-flex-gap-y-xl {
  column-gap: 40px;
}

:host([padding=xxs]),
.ids-layout-flex-padding-xxs {
  padding: 4px;
}

:host([padding-x=xxs]),
.ids-layout-flex-padding-x-xxs {
  padding-inline: 4px;
}

:host([padding-y=xxs]),
.ids-layout-flex-padding-y-xxs {
  padding-block: 4px;
}

:host([padding=xs]),
.ids-layout-flex-padding-xs {
  padding: 8px;
}

:host([padding-x=xs]),
.ids-layout-flex-padding-x-xs {
  padding-inline: 8px;
}

:host([padding-y=xs]),
.ids-layout-flex-padding-y-xs {
  padding-block: 8px;
}

:host([padding=sm]),
.ids-layout-flex-padding-sm {
  padding: 16px;
}

:host([padding-x=sm]),
.ids-layout-flex-padding-x-sm {
  padding-inline: 16px;
}

:host([padding-y=sm]),
.ids-layout-flex-padding-y-sm {
  padding-block: 16px;
}

:host([padding=md]),
.ids-layout-flex-padding-md {
  padding: 24px;
}

:host([padding-x=md]),
.ids-layout-flex-padding-x-md {
  padding-inline: 24px;
}

:host([padding-y=md]),
.ids-layout-flex-padding-y-md {
  padding-block: 24px;
}

:host([padding=lg]),
.ids-layout-flex-padding-lg {
  padding: 32px;
}

:host([padding-x=lg]),
.ids-layout-flex-padding-x-lg {
  padding-inline: 32px;
}

:host([padding-y=lg]),
.ids-layout-flex-padding-y-lg {
  padding-block: 32px;
}

:host([padding=xl]),
.ids-layout-flex-padding-xl {
  padding: 40px;
}

:host([padding-x=xl]),
.ids-layout-flex-padding-x-xl {
  padding-inline: 40px;
}

:host([padding-y=xl]),
.ids-layout-flex-padding-y-xl {
  padding-block: 40px;
}

:host([margin=xs]),
.ids-layout-flex-margin-xs {
  margin: 16px;
}

:host([margin-y=xs]),
.ids-layout-flex-margin-y-xs {
  margin-block: 16px;
}

:host([margin=sm]),
.ids-layout-flex-margin-sm {
  margin: 16px;
}

:host([margin-y=sm]),
.ids-layout-flex-margin-y-sm {
  margin-block: 16px;
}

:host([margin=md]),
.ids-layout-flex-margin-md {
  margin: 16px;
}

:host([margin-y=md]),
.ids-layout-flex-margin-y-md {
  margin-block: 16px;
}

:host([margin=lg]),
.ids-layout-flex-margin-lg {
  margin: 24px;
}

:host([margin-y=lg]),
.ids-layout-flex-margin-y-lg {
  margin-block: 24px;
}

:host([margin=xl]),
.ids-layout-flex-margin-xl {
  margin: 24px;
}

:host([margin-y=xl]),
.ids-layout-flex-margin-y-xl {
  margin-block: 24px;
}

:host([margin=auto]),
.ids-layout-flex-margin-auto {
  margin: auto;
}

:host([full-height]),
.ids-layout-flex-full-height {
  height: 100%;
}

::slotted(ids-icon),
.ids-layout-flex > .ids-icon {
  display: inline-flex;
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  block-size: 100%;
  min-block-size: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
